var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 186,
    viewBox: "0 0 106 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -21,
    cy: 59,
    r: 126.5,
    transform: "rotate(180 -21 59)",
    stroke: "#F1613F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -41,
    cy: 72,
    r: 102.5,
    transform: "rotate(180 -41 72)",
    stroke: "#29C302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/top-left.f9c2ec7197fa664180caa4d6b1287cb5.svg";
export { ForwardRef as ReactComponent };